// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../node_modules/video.js/dist/video-js.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  flex-wrap: wrap;
}

div#uploadVideoFiles {
  width: 100%;
  /* text-align: center; */
}

.HeaderMobile {
  color: #ffffff;
}

p.fileName {
  top: 26%;
  position: relative;
}

.videoPlacementContainer {
  width: 48%;
  margin: 0 auto;
  padding: 10px !important;
}

.videoPlaceContainer {
  width: 48%;
  margin: 0 auto;
  padding: 10px !important;
}

::-webkit-scrollbar {
  width: 0em;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px black;
  background-color: black;
}

::-webkit-scrollbar-thumb {
  background-color: black;
  outline: 1px solid black;
}

.videoContainer {
  width: 100%;
  overflow: auto;
}

.videoLocker-section {
  background-color: black !important;
  border-bottom: 5px solid #be1e2d;
  border-top: 5px solid #be1e2d;
}

.col-md-12.buttonFillColumn {
  width: 100%;
  align-items: center;
  display: inline-flex;
}

.col-md-3.offense {
  width: 100%;
  text-align: right;
  margin: 0px;
}

.col-md-3.defense {
  margin: 0px;
}

.col-md-3.training {
  margin: 0px;
}

.col-md-3.works {
  width: 100%;
  margin: 0px;
  text-align: left;
}

button.buttonsActiveStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  box-shadow: inset 0 0 3px grey;
  background-color: #c4481f;
  color: white;
}

button.buttonsStyles {
  padding: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  box-shadow: inset 0 0 3px grey;
  background-color: silver;
  color: white;
}

button.setFontSizeForButtons {
  font-size: 10px;
  width: 100%;
}

@media only screen and (max-width: 340px) {
  button.setFontSizeForButtons {
    font-size: 9px;
  }
}
@media screen and (device-aspect-ratio: 40/71) {
  button.setFontSizeForButtons {
    font-size: 10px;
  }
}
@media screen and (device-aspect-ratio: 2/3) {
  button.setFontSizeForButtons {
    font-size: 10px;
  }
}
@media screen and (device-aspect-ratio: 375/667) {
  button.setFontSizeForButtons {
    font-size: 10px;
  }
}
.row.videoRowAnother {
  background-color: black;
}

#uploadedVideoFiles {
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
}

#uploadedVideoFiles img {
  padding: 10px;
  width: 50%;
  float: left;
}

p.fileName {
  color: white;
  font-weight: bold;
}

span.description {
  color: gray !important;
  font-style: italic !important;
  font-weight: unset !important;
  font-size: 12px;
}

.athlete_statsMobile {
  font-size: 16px;
  border: 2px solid gray !important;
  width: 100px;
  height: 80px;
  margin: 15px auto;
  padding: 0;
  text-align: center;
}

.athlete_statsMobile label {
  white-space: pre-line;
  padding: 0px;
}

.athlete_statsMobile p {
  margin: 0px;
  color: white;
  font-size: 19px;
}

.header p {
  white-space: nowrap;
  padding: 0px;
  color: white !important;
}

.profile-box {
  flex-wrap: nowrap;
}

.header-btn {
  background-color: red;
  padding: 0px 15px;
  border-radius: 2px;
  color: white;
  font-size: 14px;
}

.toolbar-title {
  color: white !important;
}

.personal-info {
  padding: 0px 25px;
}

ion-item {
  padding: 0px !important;
  font-size: 14px !important;
}

ion-item.item-complex {
  border-top: none;
  border-bottom: none;
  margin-bottom: -5px;
}

.stats-section {
  text-align: center;
  background-color: black;
  padding: 0px 25px 25px 25px;
  border-bottom: 5px solid #be1e2d;
}

.stats-section p {
  font-size: 25px;
  color: #121a3e;
}

table {
  width: 100%;
}

th,
td {
  padding: 5px;
}

thead {
  font-size: 14px;
  background: #be1e2d;
  color: #ffffff;
}

tbody {
  background-color: white;
}

.video-section {
  text-align: center;
  margin-top: 0px;
  background-color: rgb(68, 69, 68);
  border-bottom: 5px solid #be1e2d;
  border-top: 5px solid #be1e2d;
}

.document-section {
  text-align: center;
  margin-top: 0px;
  background-color: rgb(68, 69, 68);
}

.video-section select,
.document-section select {
  font-size: 14px;
  border-radius: 3px;
  padding: 4px 10px;
  color: #555;
}

.video-section span,
.document-section span {
  padding: 5px;
  font-weight: bold;
}

.video-section p,
.document-section p {
  font-size: 16px;
  font-weight: bold;
  color: white;
}

.video-box {
  display: inline-block;
  padding: 10px;
  cursor: pointer;
}

.document-box {
  display: inline-block;
  padding: 45px;
  cursor: pointer;
  border: 1px solid white;
  margin-left: 10px;
}

.video-box div {
  min-height: 150px;
  min-width: 250px;
}

.video-box span {
  text-align: justify;
  font-weight: normal;
  font-size: 14px;
  color: white !important;
}

.video-box p,
.document-box p {
  font-size: 18px !important;
  color: white !important;
}

.video-box:hover {
  background-image: url(https://www.google.co.in/url?sa=i&rct=j&q=&esrc=s&source=images&cd=&ved=0ahUKEwjd9vbv9uvYAhXFMo8KHVfdBA8QjRwIBw&url=https%3A%2F%2Fwww.lincolncenter.org%2Fvideo&psig=AOvVaw3miScGI0tDVPIRzItaCp4R&ust=1516722801260005);
}

.document-box div {
  border: 1px solid;
  min-height: 150px;
}

.footer {
  text-align: center;
  font-size: 11px;
  font-style: italic;
  color: white;
  background: #be1e2d;
  margin-bottom: 1px !important;
}

.tab {
  overflow: hidden;
}

.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px;
  transition: 0.3s;
  font-size: 18px;
  font-weight: normal;
  color: white;
}

.tab button:hover {
  background-color: #a7a9ac;
}

.tab button.active {
  background-color: #ccc;
}

.team span,
.year span {
  padding: 5px;
  font-size: 16px;
}

.team select,
.year select {
  font-size: 14px;
  border-radius: 3px;
  width: 10%;
  padding: 4px 10px;
  color: #555;
  width: 50%;
}

.academictable {
  border: 1px solid #eaeaea;
}

.academictable tr {
  border: 1px solid #eaeaea;
}

.academictable td {
  padding: 10px !important;
}

.academic {
  color: #121a3e;
  font-size: 14px;
  font-weight: normal;
}

.academic-header {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}

label {
  padding: 5px;
  white-space: nowrap;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .team-label label {
    padding-right: 125px; /* IE 11 and below */
  }
}
@media only screen and (max-width: 1024px) {
  .tab button {
    font-size: 16px !important;
  }
}
@media only screen and (max-width: 768px) {
  .team {
    margin: auto;
  }
  .year {
    margin: auto;
  }
  .filter-label {
    margin-top: 5px !important;
  }
  .profile-info {
    margin-left: 20px;
  }
  .loading {
    width: 125px !important;
    height: 125px !important;
  }
  .ejPicker {
    padding: 0px;
  }
  .table-td {
    font-size: 14px;
    color: #121a3e;
  }
  .academictable td {
    padding: 5px !important;
  }
  .profile-box {
    margin: auto;
  }
  .profile-label label {
    font-size: 14px !important;
  }
  .loggeduser {
    font-size: 22px !important;
  }
  .schoolname {
    font-size: 16px !important;
  }
  .level {
    font-size: 13px;
  }
  .profile-athlete-info {
    margin: auto;
  }
  .profile-bbinfo {
    margin: auto;
  }
  .nav-text p {
    font-size: 12px !important;
  }
  .nav-text i {
    margin-top: 5px !important;
  }
  .table-td {
    font-size: 13px !important;
  }
  .tab button {
    font-size: 16px !important;
  }
  .academic-stats-module {
    padding: 10px 0px !important;
  }
  .academic_school label {
    color: gray;
    font-size: 16px !important;
  }
  .academic_school p {
    margin: 0px;
    color: white;
    font-size: 18px !important;
  }
  .filtertype {
    width: 35%;
    margin: auto;
  }
}
@media only screen and (max-width: 425px) {
  .tab button {
    font-size: 14px !important;
  }
  .AthleteCircleClass {
    display: inline-flex;
  }
  .AthleteAccomplishmentMobileClass {
    display: inline-flex;
  }
  .year {
    width: 100%;
    padding: 0px 10px;
  }
}
@media only screen and (min-width: 992px) {
  .profile-box {
    margin-left: 20px;
    flex-wrap: nowrap;
  }
  .profile-info {
    margin-left: 30px;
  }
  .tab-line {
    margin-left: -50px;
  }
  .next-athlete {
    margin-left: 100px;
  }
  .stats-calc-table {
    width: 70%;
    margin: auto;
  }
}
.modal-backdrop-bg {
  transition: opacity 300ms ease-in-out;
  -webkit-transition: opacity 300ms ease-in-out;
  background-color: #000;
  opacity: 0;
}

.active .modal-backdrop-bg {
  opacity: 0.5;
}

a {
  text-decoration: none;
}

.profilemenu {
  float: right;
  margin-right: 15px;
  cursor: pointer;
  height: 40px;
}

.loggeduser {
  font-weight: bold;
  font-size: 26px;
  margin: 20px 0px 0px 0px;
}

.slider {
  overflow-y: hidden;
  max-height: 500px; /* approximate max height */
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.nav-header {
  height: 45px;
  background-color: black;
  opacity: 0.7;
}

.nav-text {
  cursor: pointer;
}

.nav-text p {
  padding: 0px;
  margin: 5px 0px 0px 0px;
  color: white !important;
  font-size: 16px;
}

.stats-tbody td {
  font-size: 13px;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px; /* Safari */
  animation: spin 2s linear infinite;
  position: fixed;
  opacity: 6;
  margin: 100px 200px 100px 500px;
}

/* Safari */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.docs {
  flex-wrap: nowrap;
  overflow-x: hidden;
  width: 100%;
}

.backarrow {
  margin-top: 65px;
  cursor: pointer;
  width: 35px;
  height: 35px;
}

.updateinfo {
  width: 100%;
  height: 25px;
  background-color: #be1e2d;
  color: white;
  font-size: 14px;
  border-radius: 2px;
}

.updateinfo:hover {
  opacity: 0.7 !important;
  background-color: rgb(190, 30, 45) !important;
}

.content-md {
  background-color: black !important;
}

.profile-section {
  background: rgba(0, 0, 0, 0.47) !important;
  margin-top: 2%;
  padding: 5px;
  margin-bottom: 2%;
}

.tab-section {
  background-color: rgb(34, 36, 32);
  border-top: 5px solid #be1e2d;
}

.profile-background {
  background-image: url('output.jpg');
  background-size: 100% 150%;
}

.doc-title {
  color: white !important;
}

.profile {
  padding: 0px;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;
  margin: auto;
  border-top: 30px solid #be1e2d;
  padding-bottom: 15px;
}

.alertMessage {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  top: 0px;
  background: #b2ae5e !important;
  opacity: 0.45;
  padding: 0px;
}

p.alertText {
  text-align: center !important;
  font-size: 1.4rem;
  color: black;
  width: 98%;
}

ion-icon.iconCloseAlert {
  color: black;
  font-size: 2rem;
  padding-right: 10px;
  cursor: pointer;
  -webkit-margin-before: 0.5em;
  -webkit-margin-after: 0em;
}

.ejPicker ej-datepicker {
  border-bottom: none !important;
  padding-left: 5px !important;
}

.ejPicker ej-datepicker:focus {
  border-bottom: none !important;
}

.schoolname {
  font-size: 20px;
  color: white;
  margin: 5px 0px 0px 0px;
}

.grid {
  padding: 0px !important;
}

.level {
  padding: 0px;
  margin: 0px;
  color: white;
  font-size: 16px;
}

.e-input-group {
  width: 100% !important;
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #efefef !important;
  border-radius: 5px !important;
  height: 40px !important;
  background: white !important;
  padding: 0px !important;
}

ion-select {
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #efefef !important;
  border-radius: 5px !important;
  height: 40px !important;
  background: white !important;
  padding: 0px !important;
  padding-right: 8px !important;
}

.stats-locker {
  width: 40%;
  margin: auto;
  border: 2px solid #be1e2d !important;
  background: #be1e2d !important;
  color: white !important;
  padding: 0px 5px !important;
}

.e-input-group input.e-input,
.e-input-group input,
.e-input-group.e-control-wrapper input.e-input,
.e-input-group.e-control-wrapper input {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group input.e-input:focus,
.e-input-group.e-control-wrapper input.e-input:focus {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group.e-control-wrapper .e-input-group-icon:last-child {
  margin-right: 6px !important;
  padding-top: 6px !important;
}

.athleteTeam {
  margin: auto;
  min-width: 50%;
}

.stats-calc-table {
  margin: auto;
}

.table-td {
  font-size: 15px;
  color: #121a3e;
}

.loading {
  float: right;
  width: 175px;
  border-radius: 50%;
  height: 175px;
}

img {
  image-rendering: auto;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
}

.stats-table-mob-th {
  color: white;
  font-size: 14px;
  background: #be1e2d;
  border: 1px solid;
}

.stats-table-mob-td {
  background: black;
  color: white;
  font-size: 14px;
  border: 1px solid;
}

.profile-label {
  flex-wrap: nowrap;
  padding: 0px;
}

.no-records {
  color: white;
  padding: 0;
  margin: auto;
  text-align: center;
  font-size: 15px;
}

.modal-wrapper {
  height: 540px !important;
}

.loading-mobile {
  text-align: center;
  width: 200px;
  height: 200px;
  border-radius: 50%;
}

.profile-mobile label {
  padding: 5px;
  font-size: 15px;
}

.doc-img:hover {
  cursor: pointer;
  border: 1px solid yellow !important;
}

.academic_school {
  text-align: center;
}

.academic_school label {
  color: gray;
  font-size: 16px;
}

.academic_school p {
  margin: 0px;
  color: white;
  font-size: 22px;
}

.academic_stats {
  border: 2px solid #be1e2d;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin: auto;
  padding: 15px 10px 10px 10px;
}

.academic_stats label {
  white-space: pre-line;
  padding: 0px;
}

.awards-header {
  text-align: center;
  color: white;
  font-size: 22px;
  margin-top: 40px;
}

.awards-stats {
  min-height: 200px;
  background: #353535;
  padding: 10px;
  color: white;
  font-size: 16px;
}

.academic-stats-module {
  padding: 20px;
  margin: auto;
}

.athletic-stats label {
  color: white;
  font-size: 18px;
}

.athletic_games {
  font-size: 16px;
  border: 2px solid #be1e2d;
  width: 100px;
  height: 80px;
  margin: 15px auto;
  text-align: center;
}

.athletic_games label {
  color: gray;
  white-space: pre-line;
  padding: 0px;
  font-size: 16px;
}

.athletic_games p {
  color: white;
  text-align: center;
  margin: 10px 0px 0px 0px;
  font-size: 16px;
  display: inline-flex;
}

.offensive-stats {
  flex-wrap: nowrap;
  text-align: center;
}

.offensive-head {
  color: white;
  margin: auto;
  font-size: 16px;
}

.defensive-head {
  color: white;
  margin: auto;
  font-size: 16px;
}

.defensive-head table tbody {
  background-color: transparent;
}

.offensive-stats table tbody {
  background-color: transparent !important;
  font-size: 16px;
}

.offensive-stats table {
  height: 360px;
}

.athlete_stats_part {
  text-align: center;
}

.athlete_stats_part label {
  color: gray;
  font-size: 16px;
}

.athlete_stats_part p {
  color: white;
  font-size: 18px;
  margin-top: 2%;
}

.hide {
  display: block !important;
}

.swiper-pagination-bullet-active {
  background: #be1e2d !important;
  opacity: 1;
}

.swiper-pagination-bullet {
  opacity: 1;
}

.swiper-wrapper ion-slide {
  padding: 10px;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0px !important;
}

i {
  border: 1px solid white;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  width: 15px;
  height: 15px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.athlete_statsPitcherMobile {
  border: 2px solid #be1e2d;
  border-radius: 50%;
  width: 90px;
  height: 90px;
  margin: auto;
  padding: 20px 10px 15px 10px;
}

.athlete_statsPitcherMobile label {
  white-space: pre-line;
  padding: 0px;
}

.video-button {
  height: 30px;
  padding: 0px 91px;
  border-radius: 6px;
  margin: 0 15px;
  font-size: 15px;
  background-color: white;
}

.docs-new {
  border: 1px solid white;
  padding: 20px;
  border-radius: 50%;
  width: 125px;
  height: 125px;
  margin: auto;
  background-color: #be1e2d;
}

.nav-text i {
  margin-top: 8px;
}

.tooltiptext {
  visibility: hidden;
  background-color: #be1e2d;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  margin-top: 10px;
  margin-left: 10px;
  padding: 10px !important;
  position: absolute;
  z-index: 1;
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .tooltiptext:before {
    content: "";
    display: block;
    position: absolute;
    left: 140px;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: #be1e2d;
  }
  .tooltiptext:after {
    content: "";
    display: block;
    position: absolute;
    left: 141px;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-bottom-color: #be1e2d;
  }
}
.doc-img:hover .tooltiptext {
  visibility: visible;
}

.filtertype.e-control.e-dropdownlist span.e-input-group.e-control-wrapper.e-ddl {
  background: #be1e2d !important;
  border-color: transparent !important;
  border-radius: 2px;
  padding: 5px 5px 0px 5px;
}

.filtertype.e-control.e-dropdownlist span.e-input-group.e-control-wrapper.e-ddl input.e-input {
  color: #fff !important;
}

.filtertype.e-control.e-dropdownlist span.e-input-group-icon.e-ddl-icon.e-search-icon {
  color: #fff !important;
}

.filterRow {
  display: inline-flex;
  width: 100%;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
}

.filter-picker,
.filter-dropdown {
  margin: 2px;
  width: 33%;
}

.btn-results {
  width: 17%;
  margin: auto;
  height: 36px;
  background-color: #be1e2d;
  color: white;
  font-size: 16px;
  border-radius: 2px;
}

@media only screen and (max-width: 767px) {
  .btn-results {
    width: 35% !important;
  }
  .updateinfo {
    height: 35px !important;
  }
}
.results {
  padding: 10px 0px;
}

.row.athletic-stats {
  padding: 0% 5%;
}

.stats-spray {
  background: #000;
}

.filterRow label {
  color: #fff;
  font-size: 16px;
  margin: auto;
  width: 110px;
  text-align: right;
  padding: 0px 10px;
}

.filter-mob-lab {
  display: inline-flex;
  width: 100%;
}

.filter-mob-lab .filter-label {
  width: 33%;
  margin: auto 5px;
  color: #fff;
}

.filter-mob-lab .filter-label p {
  margin: 0px 5px;
  padding: 0px;
  text-align: left;
}

.p_label {
  color: gray;
  white-space: pre-line;
  padding: 5px 0px;
  font-size: 16px !important;
  margin: 0px !important;
}

.mob-spratyStats {
  width: 100%;
  padding: 0px;
}

.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-text,
.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text {
  color: #fff;
}

.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-text {
  color: #fff;
}

.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_0.e-toolbar-item.e-template.e-active {
  background: #be1e2d;
  border: 0px;
  border-bottom: 5px solid #be1e2d;
}

.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_0.e-toolbar-item.e-template {
  background: #a7a9ac;
  border: 0px;
  border-bottom: 5px solid #a7a9ac;
}

.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_1.e-toolbar-item.e-template.e-active {
  background: #be1e2d;
  border: 0px;
  border-bottom: 5px solid #a7a9ac;
}

.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_1.e-toolbar-item.e-template {
  background: #a7a9ac;
  border: 0px;
  border-bottom: 5px solid #be1e2d;
}

.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover {
  background: transparent !important;
}

.e-toolbar-items {
  width: 100% !important;
}

.e-toolbar .e-toolbar-items .e-toolbar-item {
  text-align: center;
  width: 50% !important;
}

.e-tab-text {
  text-transform: none !important;
}

div#e-item-statisticTab_0 {
  background: #a7a9ac;
  border: 1px solid white;
}

div#e-item-statisticTab_1 {
  background: #a7a9ac;
  border: 1px solid white;
}

.e-indicator.e-ignore {
  display: none;
}

.e-tab .e-tab-header .e-indicator {
  background: transparent !important;
}

.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text {
  color: #fff !important;
}

.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover {
  background: #a7a9ac;
}

.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-text,
.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-icon {
  color: #fff !important;
}

.e-tab-header.e-control.e-toolbar.e-keyboard {
  width: 100% !important;
  margin: auto;
}

.mob-range-filters p {
  color: #fff;
  font-size: 16px;
  width: 50%;
  margin: 10px auto;
}

.mob-filters {
  display: inline-flex;
  width: 100%;
}

.mob-filters div {
  width: 100%;
}

.mob-filters .mob-filter-dropdown {
  width: 80%;
  margin: auto;
}

.e-hscroll-content {
  display: block !important;
}

.e-toolbar-items.e-control.e-hscroll.e-touch {
  display: inline !important;
}

.e-content.e-control.e-touch {
  /*height: auto !important;*/
}

div#ej2-datetimepicker_39_popup {
  left: 35px;
}

@media only screen and (min-device-width: 425px) and (max-device-width: 768px) {
  .athlete_statsMobile,
  .athletic_games {
    width: 120px;
  }
}
.reset {
  cursor: pointer;
  padding-left: 10px;
  color: #fff;
  text-decoration: underline;
  font-size: 15px;
}

.reset:hover {
  opacity: 1 !important;
}

.results div {
  width: 100%;
  text-align: center;
}

rect#chart-container_ChartBorder {
  height: auto;
}

.chart-div {
  background: #000;
}

.add-banner {
  height: 50px;
}

.dot-1b {
  background-color: #000;
}

.dot-2b {
  background-color: blue;
}

.dot-3b {
  background-color: orange;
}

.dot-hr {
  background-color: #fff;
}

.dot-out {
  background-color: red;
}

.legend {
  display: inline-flex;
}

.legend div {
  height: 10px;
  width: 10px;
  margin: auto 0px auto 12px;
  border-radius: 50%;
}

.legend label {
  color: #fff;
}

.EJ2-Trackball {
  display: none;
}

.out-hbp {
  display: inline-flex;
  margin: auto;
}

.out-hbp .athletic_games {
  margin: auto 15px !important;
}

.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text {
  color: #fff !important;
}

#academic-document {
  border-top: 5px solid #be1e2d;
}

ion-backdrop {
  cursor: default !important;
}

.share-Icon {
  max-width: none !important;
  margin-left: 5px;
  cursor: pointer;
}

.statsTextbox {
  border: 1px solid #c4c4c4;
  border-radius: 3px;
  padding: 0px;
  box-shadow: 0 0 3px 3px #e1e1e1;
  margin-top: 2px;
  min-height: 35px;
  color: white;
  max-height: 60px;
  overflow-y: scroll;
}

.textPosition {
  padding: 5px;
  margin: 0px;
}

label {
  color: white;
}

.header-filter:after,
.header-filter:before {
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}

.header-filter::before {
  background: rgba(0, 0, 0, 0);
}

.main-raised {
  margin: 0px 5px 0;
  border-radius: 6px;
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.mobProfileImage {
  z-index: 1000000000;
  width: 150px;
  height: 150px;
  margin-left: 5% !important;
  margin-top: 20%;
  bottom: 15px;
  position: relative;
  border-radius: 50%;
  border: 2px solid white;
}

.atheleteProfileImage {
  width: 150px;
  height: 150px;
  margin-left: 5% !important;
  margin-top: 15%;
  bottom: 15px;
  position: relative;
  border-radius: 50%;
  border: 2px solid white;
  object-fit: cover;
}

.profileImageGridStyle {
  height: 150px;
  background-image: url('bg_grass.jpg');
  background-size: 100% 100%;
}

.backgroundImage {
  background-image: url('bg_grass.jpg');
  background-size: 100% 100%;
  height: 150px;
}

.shareIcon {
  margin-top: 40%;
  color: white;
  font-size: 25px;
  cursor: pointer;
}

.editButton {
  padding: 0px;
  width: 50px;
  position: absolute;
  right: 15px;
  background-color: #be1e2d;
  color: white;
  padding: 5px;
}

.editButton:hover {
  opacity: 0.7 !important;
  background-color: rgb(190, 30, 45) !important;
}

.editInfo {
  margin-top: 65px;
}

.shareAtheleteName {
  z-index: 1000000;
  margin-left: 5%;
  margin-top: 10%;
  font-size: 25px;
  height: 3em;
  overflow: hidden;
}

@media only screen and (min-width: 320px) and (max-width: 765px) {
  .profile-content-height {
    height: auto !important;
  }
  .ageColumn {
    margin-left: 0px;
  }
  .leagueColumn {
    margin-left: 15px;
  }
  .main-raised {
    padding: 0px 5px 0;
    background-color: #4e4a4b !important;
    margin: 0 !important;
    border-radius: 0;
  }
  .publicShare-stats {
    /*background:black !important;*/
    border-right: 2px solid #161717;
  }
  .shareAtheleteName {
    z-index: 1000000;
    margin-left: 5%;
    margin-top: 10%;
    font-size: 25px;
    height: 3em;
    overflow: hidden;
  }
  .statsTextbox {
    color: white !important;
    border: 2px solid white !important;
    border-radius: 5px !important;
    background: black !important;
    box-shadow: none !important;
    font-size: 13px;
    height: 40px;
    padding: 5px;
  }
  label {
    color: white;
    font-size: 13px;
  }
  .deskmain-raised {
    margin: 0px !important;
  }
  .mobProfileImage {
    z-index: 1000000000;
    width: 150px;
    height: 150px;
    margin-left: 5% !important;
    margin-top: 20%;
    bottom: 15px;
    position: relative;
    border-radius: 50%;
    border: 2px solid white;
  }
  .mobAthleteName {
    z-index: 1000000;
    margin-left: 42%;
    margin-top: 11%;
    font-size: 33px;
  }
  .legend {
    display: inline-flex;
  }
  .headerData {
    /*background: #161717;*/
    background: #a7a9ac;
    padding: 5px 0;
    border-bottom: 1px solid #161717;
  }
  .resultData {
    padding: 5px 0;
  }
  p.p_label {
    font-weight: bold;
    font-size: 16px;
    padding: 5px 0;
    color: black;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 100%;
  }
}
.col-6 {
  padding-right: 5px !important;
  padding-left: 10px !important;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-3 {
  padding-right: 5px !important;
  padding-left: 10px !important;
  flex: 0 0 25%;
  max-width: none !important;
}

.col-12 {
  padding-right: 5px !important;
  padding-left: 10px !important;
  flex: 0 0 100%;
  max-width: 100%;
}

.headerName {
  font-size: 18px;
}

.filter-label1 {
  width: 50%;
  margin: auto 5px;
  color: #fff;
}

.page-headerBg {
  background-image: url('bg_grass.jpg');
  height: 20vh;
}

.videoBackButton {
  color: white;
  background: transparent;
  transform: translate(15px, -40px) !important;
  font-size: 16px !important;
  z-index: 100000;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .profile-content-height {
    height: auto !important;
  }
  .shareIcon {
    margin-top: 20% !important;
  }
  .main-raised {
    padding: 0px 5px 0;
    background-color: #4e4a4b !important;
    margin: 0 !important;
    border-radius: 0;
  }
  .publicShare-stats {
    /*background:black !important;*/
    border-right: 2px solid #161717;
  }
  .shareAtheleteName {
    z-index: 1000000;
    margin-left: 20%;
    margin-top: 15%;
    font-size: 25px;
    height: 3em;
    overflow: hidden;
  }
  .statsTextbox {
    color: white !important;
    border: 2px solid white !important;
    border-radius: 5px !important;
    background: black !important;
    box-shadow: none !important;
    font-size: 13px;
  }
  label {
    color: white;
    font-size: 13px;
  }
  .mobProfileImage {
    z-index: 1000000000;
    width: 300px;
    height: 300px;
    margin-left: 10%;
    margin-top: 20%;
    bottom: 15px;
    position: relative;
    border-radius: 50%;
    border: 2px solid white;
  }
  .mobAthleteName {
    z-index: 1000000;
    margin-left: 42%;
    margin-top: 11%;
    font-size: 33px;
  }
  .legend {
    display: inline-flex;
  }
  .page-header {
    height: 25vh;
    background-size: cover;
    margin: 0;
    padding: 0;
    border: 0;
    display: flex;
    align-items: center;
  }
  .headerData {
    /*background: #161717;*/
    background: #a7a9ac;
    padding: 5px 0;
    border-bottom: 1px solid #161717;
  }
  .resultData {
    padding: 5px 0;
  }
  p.p_label {
    font-weight: bold;
    font-size: 16px;
    padding: 5px 0;
    color: black;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .profile-content-height {
    padding-top: 80px !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .profile-content-height {
    padding-top: 125px !important;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 765px) and (orientation: portrait) {
  .profile-content-height {
    padding-top: 50px !important;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 765px) and (orientation: landscape) {
  .profile-content-height {
    padding-top: 80px !important;
  }
}
.athletetabs-section {
  padding-bottom: 10px;
  width: 100%;
}

.header-style {
  background-color: #c01e2d;
  top: -100px;
  width: 100%;
  display: block;
  transition: top 0.3s;
  position: fixed;
  overflow: hidden;
  z-index: 10001;
  padding: 5px;
  opacity: 0.9;
}

.header,
span.label-name {
  font-size: 20px;
  color: floralwhite;
}

.athleteNameStyles {
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 500;
  margin: 0px;
  margin-bottom: 15px;
}

.ageBox {
  flex: unset !important;
  padding: 0px;
}

@media only screen and (min-device-width: 220px) and (max-device-width: 425px) {
  .statsTextbox,
  label {
    font-size: 13px;
  }
}
.gradeBox {
  width: 70% !important;
  max-width: 70% !important;
  padding-left: 0px !important;
}

.ageBoxPosition {
  width: 30% !important;
  max-width: 30% !important;
  padding-right: 0px !important;
}

.spray-tab-header-section {
  width: 100%;
  text-align: center;
  padding: 0px 0px 0px 0px !important;
  display: flex;
  color: #fff;
  font-size: 16px;
}
.spray-tab-header-section .spray-tab {
  border: 1px solid white;
  height: 60px;
  width: 50%;
  background-color: transparent;
  line-height: 60px;
}
.spray-tab-header-section .spray-active {
  background-color: rgb(167, 169, 172);
}

.spray-hide {
  display: none;
}

@media only screen and (min-device-width: 515px) and (max-device-width: 1024px) {
  p.fileName {
    position: relative;
    font-size: 10px;
  }
  #uploadedVideoFiles p {
    width: 50%;
    text-align: right;
    float: left;
    padding: 46px 1em;
    top: 0;
    margin: 0;
  }
  .videoPlacementContainer {
    padding: 10px;
    width: 250px;
    float: left;
    margin: auto;
  }
  .videoPlaceContainer {
    width: 75%;
    margin: 0 auto;
    padding: 10px !important;
  }
}
@media only screen and (max-width: 515px) {
  p.fileName {
    position: relative;
    font-size: 10px;
  }
  #uploadedVideoFiles p {
    width: calc(100% - 250px);
    text-align: right;
    float: left;
    padding: 46px 1em;
    top: 0;
    margin: 0;
  }
  .videoPlacementContainer {
    padding: 10px;
    width: 60%;
    float: left;
  }
  .videoPlaceContainer {
    width: 75%;
    margin: 0 auto;
    padding: 10px !important;
  }
}
::ng-deep .viewprofile-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0;
}
::ng-deep .viewprofile-popover ion-item ion-label {
  color: #000000 !important;
}
::ng-deep .viewprofile-popover ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

.e-item .e-active {
  padding: 30px 10px;
}

.share-model .modal-wrapper {
  height: 290px !important;
}

.profile-10 .profile-bbinfo {
  margin: 0px 50px;
}

.profile_label_10 {
  width: 120px;
  text-align: right;
}

.textContentsWidth {
  padding: 15px;
  padding-left: 0px;
  width: 80%;
  padding-bottom: 0px;
}

.textContents {
  width: 100%;
  display: inline-flex;
}

span.fileContentsName {
  color: white;
}

.menuContents {
  width: 20%;
}

p.contextMenuDesign {
  color: white;
  font-size: 18px;
  text-align: right;
  padding-right: 20px;
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/view-profile/view-profile.page.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,QAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,cAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,cAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,uCAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,cAAA;AAAJ;;AAGA;EACI,kCAAA;EACA,gCAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,WAAA;EACA,mBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,iBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,WAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EAGA,8BAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;EACA,6BAAA;EACA,8BAAA;EAGA,8BAAA;EACA,wBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,WAAA;AAAJ;;AAGA;EACI;IACI,cAAA;EAAN;AACF;AAGA;EACI;IACI,eAAA;EADN;AACF;AAIA;EACI;IACI,eAAA;EAFN;AACF;AAKA;EACI;IACI,eAAA;EAHN;AACF;AAMA;EACI,uBAAA;AAJJ;;AAOA;EACI,cAAA;EACA,gBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,aAAA;EACA,UAAA;EACA,WAAA;AAJJ;;AAOA;EACI,YAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;AAJJ;;AAOA;EACI,eAAA;EACA,iCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAJJ;;AAOA;EACI,mBAAA;EACA,YAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAJJ;;AAOA;EACI,uBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gCAAA;AAJJ;;AAOA;EACI,eAAA;EACA,cAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;;EAEI,YAAA;AAJJ;;AAOA;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AAJJ;;AAOA;EACI,uBAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,eAAA;EACA,iCAAA;EACA,gCAAA;EACA,6BAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,eAAA;EACA,iCAAA;AAJJ;;AAQA;;EAEI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AALJ;;AAQA;;EAEI,YAAA;EACA,iBAAA;AALJ;;AAQA;;EAEI,eAAA;EACA,iBAAA;EACA,YAAA;AALJ;;AAQA;EACI,qBAAA;EACA,aAAA;EACA,eAAA;AALJ;;AAQA;EACI,qBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AALJ;;AAQA;EACI,iBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AALJ;;AAQA;;EAEI,0BAAA;EACA,uBAAA;AALJ;;AAQA;EACI,6OAAA;AALJ;;AAQA;EACI,iBAAA;EACA,iBAAA;AALJ;;AAcA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ;;AAcA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,sBAAA;AAXJ;;AAcA;;EAEI,YAAA;EACA,eAAA;AAXJ;;AAcA;;EAEI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,yBAAA;AAXJ;;AAcA;EACI,wBAAA;AAXJ;;AAcA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AAXJ;;AAcA;EACI,kBAAA;EACA,iBAAA;EACA,eAAA;AAXJ;;AAcA;EACI,YAAA;EACA,mBAAA;AAXJ;;AAgBA;EACI,6BAAA;EACA;IACI,oBAAA,EAAA,oBAAA;EAbN;AACF;AAgBA;EACI;IACI,0BAAA;EAdN;AACF;AAiBA;EACI;IACI,YAAA;EAfN;EAkBE;IACI,YAAA;EAhBN;EAmBE;IACI,0BAAA;EAjBN;EAoBE;IACI,iBAAA;EAlBN;EAqBE;IACI,uBAAA;IACA,wBAAA;EAnBN;EAsBE;IACI,YAAA;EApBN;EAuBE;IACI,eAAA;IACA,cAAA;EArBN;EAwBE;IACI,uBAAA;EAtBN;EAyBE;IACI,YAAA;EAvBN;EA0BE;IACI,0BAAA;EAxBN;EA2BE;IACI,0BAAA;EAzBN;EA4BE;IACI,0BAAA;EA1BN;EA6BE;IACI,eAAA;EA3BN;EA8BE;IACI,YAAA;EA5BN;EA+BE;IACI,YAAA;EA7BN;EAgCE;IACI,0BAAA;EA9BN;EAiCE;IACI,0BAAA;EA/BN;EAkCE;IACI,0BAAA;EAhCN;EAmCE;IACI,0BAAA;EAjCN;EAoCE;IACI,4BAAA;EAlCN;EAqCE;IACI,WAAA;IACA,0BAAA;EAnCN;EAsCE;IACI,WAAA;IACA,YAAA;IACA,0BAAA;EApCN;EAuCE;IACI,UAAA;IACA,YAAA;EArCN;AACF;AAwCA;EACI;IACI,0BAAA;EAtCN;EA0CE;IACI,oBAAA;EAxCN;EA2CE;IACI,oBAAA;EAzCN;EA4CE;IACI,WAAA;IACA,iBAAA;EA1CN;AACF;AA6CA;EACI;IACI,iBAAA;IACA,iBAAA;EA3CN;EA8CE;IACI,iBAAA;EA5CN;EA+CE;IACI,kBAAA;EA7CN;EAgDE;IACI,kBAAA;EA9CN;EAiDE;IACI,UAAA;IACA,YAAA;EA/CN;AACF;AAkDA;EACI,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,UAAA;AAhDJ;;AAmDA;EACI,YAAA;AAhDJ;;AAmDA;EACI,qBAAA;AAhDJ;;AAmDA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAhDJ;;AAmDA;EACI,iBAAA;EACA,eAAA;EACA,wBAAA;AAhDJ;;AAmDA;EACI,kBAAA;EACA,iBAAA,EAAA,2BAAA;EACA,wBAAA;EACA,yBAAA;EACA,sDAAA;AAhDJ;;AAmDA;EACI,YAAA;EACA,uBAAA;EACA,YAAA;AAhDJ;;AAmDA;EACI,eAAA;AAhDJ;;AAmDA;EACI,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AAhDJ;;AAmDA;EACI,eAAA;AAhDJ;;AAmDA;EACI,0BAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA,EACA,WAAA;EACA,kCAAA;EACA,eAAA;EACA,UAAA;EACA,+BAAA;AAhDJ;;AAkDA,WAAA;AAWA;EACI;IACI,uBAAA;EAjDN;EAoDE;IACI,yBAAA;EAlDN;AACF;AAqDA;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AAnDJ;;AAsDA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAnDJ;;AAsDA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAnDJ;;AAsDA;EACI,uBAAA;EACA,6CAAA;AAnDJ;;AAqDA;EACI,kCAAA;AAlDJ;;AAqDA;EACI,0CAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAlDJ;;AAqDA;EACI,iCAAA;EACA,6BAAA;AAlDJ;;AAsDA;EACI,mCAAA;EACA,0BAAA;AAnDJ;;AA+DA;EACI,uBAAA;AA5DJ;;AA+DA;EACI,YAAA;AA5DJ;;AA+DA;EACI,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;AA5DJ;;AA+DA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,YAAA;AA5DJ;;AA+DA;EACI,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;AA5DJ;;AA+DA;EACI,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;AA5DJ;;AAoEA;EACI,8BAAA;EACA,4BAAA;AAjEJ;;AAoEA;EACI,8BAAA;AAjEJ;;AAoEA;EACI,eAAA;EACA,YAAA;EACA,uBAAA;AAjEJ;;AAoEA;EACI,uBAAA;AAjEJ;;AAoEA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAjEJ;;AAoEA;EACI,sBAAA;EACA,wCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,uBAAA;AAjEJ;;AAmEA;EACI,wCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;AAhEJ;;AAmEA;EACI,UAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,2BAAA;AAhEJ;;AAmEA;;;;EAII,kBAAA;EACA,iBAAA;AAhEJ;;AAmEA;;EAEI,kBAAA;EACA,iBAAA;AAhEJ;;AAmEA;EACI,4BAAA;EACA,2BAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,cAAA;AAhEJ;;AAmEA;EACI,YAAA;AAhEJ;;AAmEA;EACI,eAAA;EACA,cAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAhEJ;;AAmEA;EACI,qBAAA;EACA,4BAAA;EACA,0BAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAhEJ;;AAmEA;EACI,iBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAhEJ;;AAmEA;EACI,iBAAA;EACA,YAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,wBAAA;AAhEJ;;AAmEA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,eAAA;EACA,mCAAA;AAhEJ;;AAmEA;EACI,kBAAA;AAhEJ;;AAmEA;EACI,WAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;AAhEJ;;AAmEA;EACI,qBAAA;EACA,YAAA;AAhEJ;;AAmEA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAhEJ;;AAmEA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,aAAA;EACA,YAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhEJ;;AAmEA;EACI,WAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;AAhEJ;;AAmEA;EACI,iBAAA;EACA,kBAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,6BAAA;AAhEJ;;AAmEA;EACI,wCAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,aAAA;AAhEJ;;AAmEA;EACI,kBAAA;AAhEJ;;AAmEA;EACI,WAAA;EACA,eAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,eAAA;EACA,cAAA;AAhEJ;;AAmEA;EACI,yBAAA;AAhEJ;;AAmEA;EACI,8BAAA;EACA,UAAA;AAhEJ;;AAmEA;EACI,UAAA;AAhEJ;;AAmEA;EACI,aAAA;AAhEJ;;AAmEA;;;EAGI,sBAAA;AAhEJ;;AAmEA;EACI,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAhEJ;;AAmEA;EACI,yBAAA;EACA,iCAAA;AAhEJ;;AAmEA;EACI,yBAAA;EACA,iCAAA;AAhEJ;;AAmEA;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AAhEJ;;AAmEA;EACI,qBAAA;EACA,YAAA;AAhEJ;;AAmEA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAhEJ;;AAmEA;EACI,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AAhEJ;;AAmEA;EACI,eAAA;AAhEJ;;AAmEA;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;AAhEJ;;AAmEA;EACI;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;IACA,8BAAA;IACA,4BAAA;EAhEN;EAmEE;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;IACA,6BAAA;IACA,4BAAA;EAjEN;AACF;AAoEA;EACI,mBAAA;AAlEJ;;AAqEA;EACI,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,wBAAA;AAlEJ;;AAqEA;EACI,sBAAA;AAlEJ;;AAqEA;EACI,sBAAA;AAlEJ;;AAqEA;EACI,oBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAlEJ;;AAqEA;;EAEI,WAAA;EACA,UAAA;AAlEJ;;AAqEA;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAlEJ;;AAqEA;EACI;IACI,qBAAA;EAlEN;EAoEE;IACI,uBAAA;EAlEN;AACF;AAqEA;EACI,iBAAA;AAnEJ;;AAsEA;EACI,cAAA;AAnEJ;;AAsEA;EACI,gBAAA;AAnEJ;;AAsEA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAnEJ;;AAsEA;EACI,oBAAA;EACA,WAAA;AAnEJ;;AAsEA;EACI,UAAA;EACA,gBAAA;EACA,WAAA;AAnEJ;;AAsEA;EACI,eAAA;EACA,YAAA;EACA,gBAAA;AAnEJ;;AAsEA;EAEI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;AApEJ;;AAuEA;EACI,WAAA;EACA,YAAA;AApEJ;;AAuEA;;EAEI,WAAA;AApEJ;;AAuEA;EACI,WAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,WAAA;EACA,gCAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,WAAA;EACA,gCAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,WAAA;EACA,gCAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,WAAA;EACA,gCAAA;AApEJ;;AAuEA;EACI,kCAAA;AApEJ;;AAuEA;EACI,sBAAA;AApEJ;;AAuEA;EACI,kBAAA;EACA,qBAAA;AApEJ;;AAuEA;EACI,+BAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,uBAAA;AApEJ;;AAuEA;EACI,mBAAA;EACA,uBAAA;AApEJ;;AAuEA;EACI,aAAA;AApEJ;;AAuEA;EACI,kCAAA;AApEJ;;AAuEA;EACI,sBAAA;AApEJ;;AAuEA;EACI,mBAAA;AApEJ;;AAuEA;;EAEI,sBAAA;AApEJ;;AAuEA;EACI,sBAAA;EACA,YAAA;AApEJ;;AAuEA;EACI,WAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AApEJ;;AAuEA;EACI,oBAAA;EACA,WAAA;AApEJ;;AAuEA;EACI,WAAA;AApEJ;;AAuEA;EACI,UAAA;EACA,YAAA;AApEJ;;AAuEA;EACI,yBAAA;AApEJ;;AAuEA;EACI,0BAAA;AApEJ;;AAuEA;EACI,2BAAA;AApEJ;;AAuEA;EACI,UAAA;AApEJ;;AAuEA;EACI;;IAEI,YAAA;EApEN;AACF;AAuEA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;AArEJ;;AAwEA;EACI,qBAAA;AArEJ;;AAwEA;EACI,WAAA;EACA,kBAAA;AArEJ;;AA0EA;EACI,YAAA;AAvEJ;;AA4EA;EACI,gBAAA;AAzEJ;;AA4EA;EACI,YAAA;AAzEJ;;AA4EA;EACI,sBAAA;AAzEJ;;AA4EA;EACI,sBAAA;AAzEJ;;AA4EA;EACI,wBAAA;AAzEJ;;AA4EA;EACI,sBAAA;AAzEJ;;AA4EA;EACI,qBAAA;AAzEJ;;AA4EA;EACI,oBAAA;AAzEJ;;AA8EA;EACI,YAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AA3EJ;;AA8EA;EACI,WAAA;AA3EJ;;AA8EA;EACI,aAAA;AA3EJ;;AA8EA;EACI,oBAAA;EACA,YAAA;AA3EJ;;AA8EA;EACI,4BAAA;AA3EJ;;AA8EA;EACI,sBAAA;AA3EJ;;AA8EA;EACI,6BAAA;AA3EJ;;AA8EA;EACI,0BAAA;AA3EJ;;AA8EA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;AA3EJ;;AA6EA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EAEA,kBAAA;AA3EJ;;AA8EA;EACI,YAAA;EACA,WAAA;AA3EJ;;AA8EA;EACI,YAAA;AA3EJ;;AA6EA;;EAEI,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AA1EJ;;AA6EA;EACI,4BAAA;AA1EJ;;AA6EA;EACI,iBAAA;EACA,kBAAA;EACA,uHAAA;AA1EJ;;AA6EA;EACI,mBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AA1EJ;;AA6EA;EAEI,YAAA;EACA,aAAA;EACA,0BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;AA3EJ;;AA8EA;EACI,aAAA;EACA,qCAAA;EACA,0BAAA;AA3EJ;;AA8EA;EACI,qCAAA;EACA,0BAAA;EACA,aAAA;AA3EJ;;AA6EA;EACI,eAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA1EJ;;AA4EA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAzEJ;;AA2EA;EACI,uBAAA;EACA,6CAAA;AAxEJ;;AA0EA;EACI,gBAAA;AAvEJ;;AAyEA;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAtEJ;;AAwEA;EACI;IACI,uBAAA;EArEN;EAwEE;IACI,gBAAA;EAtEN;EAyEE;IACI,iBAAA;EAvEN;EA0EE;IACI,kBAAA;IACA,oCAAA;IACA,oBAAA;IACA,gBAAA;EAxEN;EA2EE;IACI,+BAAA;IACA,+BAAA;EAzEN;EA4EE;IACI,gBAAA;IACA,eAAA;IACA,eAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EA1EN;EA6EE;IACI,uBAAA;IACA,kCAAA;IACA,6BAAA;IACA,4BAAA;IAEA,2BAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;EA3EN;EA8EE;IACI,YAAA;IACA,eAAA;EA5EN;EA+EE;IACI,sBAAA;EA7EN;EAgFE;IACI,mBAAA;IACA,YAAA;IACA,aAAA;IACA,0BAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;IACA,uBAAA;EA9EN;EAiFE;IACI,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA/EN;EAkFE;IACI,oBAAA;EAhFN;EAmFE;IACI,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,gCAAA;EAjFN;EAoFE;IACI,cAAA;EAlFN;EAqFE;IACI,iBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EAnFN;AACF;AAqFA;EACI;IACI,eAAA;EAnFN;AACF;AAqFA;EACI,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;AAnFJ;;AAqFA;EACI,6BAAA;EACA,6BAAA;EAIA,aAAA;EACA,0BAAA;AAlFJ;;AAoFA;EACI,6BAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAjFJ;;AAmFA;EACI,eAAA;AAhFJ;;AAkFA;EACI,UAAA;EACA,gBAAA;EACA,WAAA;AA/EJ;;AAkFA;EACI,qCAAA;EACA,YAAA;AA/EJ;;AAiFA;EACI,YAAA;EACA,uBAAA;EACA,4CAAA;EACA,0BAAA;EACA,eAAA;AA9EJ;;AAiFA;EACI;IACI,uBAAA;EA9EN;EAiFE;IACI,0BAAA;EA/EN;EAkFE;IACI,kBAAA;IACA,oCAAA;IACA,oBAAA;IACA,gBAAA;EAhFN;EAmFE;IACI,+BAAA;IACA,+BAAA;EAjFN;EAoFE;IACI,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;EAlFN;EAqFE;IACI,uBAAA;IACA,kCAAA;IACA,6BAAA;IACA,4BAAA;IAEA,2BAAA;IACA,eAAA;EAnFN;EAsFE;IACI,YAAA;IACA,eAAA;EApFN;EAuFE;IACI,mBAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;IACA,uBAAA;EArFN;EAwFE;IACI,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAtFN;EAyFE;IACI,oBAAA;EAvFN;EA0FE;IACI,YAAA;IACA,sBAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;EAxFN;EA2FE;IACI,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,gCAAA;EAzFN;EA4FE;IACI,cAAA;EA1FN;EA6FE;IACI,iBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EA3FN;AACF;AA8FA;EACI;IACI,4BAAA;EA5FN;AACF;AA+FA;EACI;IACI,6BAAA;EA7FN;AACF;AAgGA;EACI;IACI,4BAAA;EA9FN;AACF;AAiGA;EACI;IACI,4BAAA;EA/FN;AACF;AAkGA;EACI,oBAAA;EACA,WAAA;AAhGJ;;AAmGA;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AAhGJ;;AAmGA;;EAEI,eAAA;EACA,kBAAA;AAhGJ;;AAmGA;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAhGJ;;AAmGA;EACI,sBAAA;EACA,YAAA;AAhGJ;;AAmGA;EACI;;IAEI,eAAA;EAhGN;AACF;AAmGA;EACI,qBAAA;EACA,yBAAA;EACA,4BAAA;AAjGJ;;AAoGA;EACI,qBAAA;EACA,yBAAA;EACA,6BAAA;AAjGJ;;AAqGA;EACI,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAlGJ;AAoGI;EACI,uBAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;AAlGR;AAqGI;EACI,oCAAA;AAnGR;;AAuGA;EACI,aAAA;AApGJ;;AAoHA;EACI;IACI,kBAAA;IACA,eAAA;EAjHN;EAoHE;IACI,UAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;IACA,MAAA;IACA,SAAA;EAlHN;EAqHE;IACI,aAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;EAnHN;EAsHE;IACI,UAAA;IACA,cAAA;IACA,wBAAA;EApHN;AACF;AAuHA;EACI;IACI,kBAAA;IACA,eAAA;EArHN;EAwHE;IACI,yBAAA;IACA,iBAAA;IACA,WAAA;IACA,iBAAA;IACA,MAAA;IACA,SAAA;EAtHN;EA2HE;IACI,aAAA;IACA,UAAA;IACA,WAAA;EAzHN;EA4HI;IACE,UAAA;IACA,cAAA;IACA,wBAAA;EA1HN;AACF;AA8HI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,+BAAA;AA5HR;AA6HQ;EACI,yBAAA;AA3HZ;AA6HQ;EACI,iCAAA;AA3HZ;;AAgIA;EACI,kBAAA;AA7HJ;;AAgIA;EACI,wBAAA;AA7HJ;;AA+HA;EACI,gBAAA;AA5HJ;;AA+HA;EACI,YAAA;EACA,iBAAA;AA5HJ;;AA+HA;EACI,aAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AA5HJ;;AA+HA;EACI,WAAA;EACA,oBAAA;AA5HJ;;AA+HE;EACE,YAAA;AA5HJ;;AA+HE;EACE,UAAA;AA5HJ;;AA+HE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA5HJ","sourcesContent":["@import \"~video.js/dist/video-js.css\";\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\ndiv#uploadVideoFiles {\n    width: 100%;\n    /* text-align: center; */\n  }\n\n.HeaderMobile {\n    color: #ffffff;\n}\n\np.fileName {\n    top: 26%;\n    position: relative;\n}\n\n.videoPlacementContainer {\n    width: 48%;\n    margin: 0 auto;\n    padding: 10px !important;\n}\n\n.videoPlaceContainer {\n    width: 48%;\n    margin: 0 auto;\n    padding: 10px !important;\n  }\n\n::-webkit-scrollbar {\n    width: 0em;\n}\n\n::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 0px black;\n    background-color: black;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: black;\n    outline: 1px solid black;\n}\n\n.videoContainer {\n    width: 100%;\n    overflow: auto;\n}\n\n.videoLocker-section {\n    background-color: black !important;\n    border-bottom: 5px solid #be1e2d;\n    border-top: 5px solid #be1e2d;\n}\n\n.col-md-12.buttonFillColumn {\n    width: 100%;\n    align-items: center;\n    display: inline-flex;\n}\n\n.col-md-3.offense {\n    width: 100%;\n    text-align: right;\n    margin: 0px;\n}\n\n.col-md-3.defense {\n    margin: 0px;\n}\n\n.col-md-3.training {\n    margin: 0px;\n}\n\n.col-md-3.works {\n    width: 100%;\n    margin: 0px;\n    text-align: left;\n}\n\nbutton.buttonsActiveStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    -webkit-box-shadow: inset 0 0 0px grey;\n    -moz-box-shadow: inset 0 0 0px grey;\n    box-shadow: inset 0 0 3px grey;\n    background-color: #c4481f;\n    color: white;\n}\n\nbutton.buttonsStyles {\n    padding: 10px;\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    -webkit-box-shadow: inset 0 0 0px grey;\n    -moz-box-shadow: inset 0 0 0px grey;\n    box-shadow: inset 0 0 3px grey;\n    background-color: silver;\n    color: white;\n}\n\nbutton.setFontSizeForButtons {\n    font-size: 10px;\n    width: 100%;\n}\n\n@media only screen and (max-width: 340px) {\n    button.setFontSizeForButtons {\n        font-size: 9px;\n    }\n}\n\n@media screen and (device-aspect-ratio: 40/71) {\n    button.setFontSizeForButtons {\n        font-size: 10px;\n    }\n}\n\n@media screen and (device-aspect-ratio: 2/3) {\n    button.setFontSizeForButtons {\n        font-size: 10px;\n    }\n}\n\n@media screen and (device-aspect-ratio: 375/667) {\n    button.setFontSizeForButtons {\n        font-size: 10px;\n    }\n}\n\n.row.videoRowAnother {\n    background-color: black;\n}\n\n#uploadedVideoFiles {\n    margin: 0 auto;\n    overflow: hidden;\n    width: 100%;\n}\n\n#uploadedVideoFiles img {\n    padding: 10px;\n    width: 50%;\n    float: left;\n}\n\np.fileName {\n    color: white;\n    font-weight: bold;\n}\n\nspan.description {\n    color: gray !important;\n    font-style: italic !important;\n    font-weight: unset !important;\n    font-size: 12px;\n}\n\n.athlete_statsMobile {\n    font-size: 16px;\n    border: 2px solid gray !important;\n    width: 100px;\n    height: 80px;\n    margin: 15px auto;\n    padding: 0;\n    text-align: center;\n}\n\n.athlete_statsMobile label {\n    white-space: pre-line;\n    padding: 0px;\n}\n\n.athlete_statsMobile p {\n    margin: 0px;\n    color: white;\n    font-size: 19px;\n}\n\n.header p {\n    white-space: nowrap;\n    padding: 0px;\n    color: white !important;\n}\n\n.profile-box {\n    flex-wrap: nowrap;\n}\n\n.header-btn {\n    background-color: red;\n    padding: 0px 15px;\n    border-radius: 2px;\n    color: white;\n    font-size: 14px;\n}\n\n.toolbar-title {\n    color: white !important;\n}\n\n.personal-info {\n    padding: 0px 25px;\n}\n\nion-item {\n    padding: 0px !important;\n    font-size: 14px !important;\n}\n\nion-item.item-complex {\n    border-top: none;\n    border-bottom: none;\n    margin-bottom: -5px;\n}\n\n.stats-section {\n    text-align: center;\n    background-color: black;\n    padding: 0px 25px 25px 25px;\n    border-bottom: 5px solid #be1e2d;\n}\n\n.stats-section p {\n    font-size: 25px;\n    color: #121a3e;\n}\n\ntable {\n    width: 100%;\n}\n\nth,\ntd {\n    padding: 5px;\n}\n\nthead {\n    font-size: 14px;\n    background: #be1e2d;\n    color: #ffffff;\n}\n\ntbody {\n    background-color: white;\n}\n\n.video-section {\n    text-align: center;\n    margin-top: 0px;\n    background-color: rgb(68, 69, 68);\n    border-bottom: 5px solid #be1e2d;\n    border-top: 5px solid #be1e2d;\n}\n\n.document-section {\n    text-align: center;\n    margin-top: 0px;\n    background-color: rgb(68, 69, 68);\n    // border-bottom: 5px solid #be1e2d;\n}\n\n.video-section select,\n.document-section select {\n    font-size: 14px;\n    border-radius: 3px;\n    padding: 4px 10px;\n    color: #555;\n}\n\n.video-section span,\n.document-section span {\n    padding: 5px;\n    font-weight: bold;\n}\n\n.video-section p,\n.document-section p {\n    font-size: 16px;\n    font-weight: bold;\n    color: white;\n}\n\n.video-box {\n    display: inline-block;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.document-box {\n    display: inline-block;\n    padding: 45px;\n    cursor: pointer;\n    border: 1px solid white;\n    margin-left: 10px;\n}\n\n.video-box div {\n    min-height: 150px;\n    min-width: 250px;\n}\n\n.video-box span {\n    text-align: justify;\n    font-weight: normal;\n    font-size: 14px;\n    color: white !important;\n}\n\n.video-box p,\n.document-box p {\n    font-size: 18px !important;\n    color: white !important;\n}\n\n.video-box:hover {\n    background-image: url(https://www.google.co.in/url?sa=i&rct=j&q=&esrc=s&source=images&cd=&ved=0ahUKEwjd9vbv9uvYAhXFMo8KHVfdBA8QjRwIBw&url=https%3A%2F%2Fwww.lincolncenter.org%2Fvideo&psig=AOvVaw3miScGI0tDVPIRzItaCp4R&ust=1516722801260005);\n}\n\n.document-box div {\n    border: 1px solid;\n    min-height: 150px;\n}\n// .document-box img{\n//     margin: 25px;\n//     width: 200px;\n// }\n// ion-footer{\n//     background-color: rgb(247, 247, 247)\n// }\n.footer {\n    text-align: center;\n    font-size: 11px;\n    font-style: italic;\n    color: white;\n    background: #be1e2d;\n    margin-bottom: 1px !important;\n}\n\n.tab {\n    overflow: hidden;\n}\n\n.tab button {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px;\n    transition: 0.3s;\n    font-size: 18px;\n    font-weight: normal;\n    color: white;\n}\n\n.tab button:hover {\n    background-color: #a7a9ac;\n}\n\n.tab button.active {\n    background-color: #ccc;\n}\n\n.team span,\n.year span {\n    padding: 5px;\n    font-size: 16px;\n}\n\n.team select,\n.year select {\n    font-size: 14px;\n    border-radius: 3px;\n    width: 10%;\n    padding: 4px 10px;\n    color: #555;\n    width: 50%;\n}\n\n.academictable {\n    border: 1px solid #eaeaea;\n}\n\n.academictable tr {\n    border: 1px solid #eaeaea;\n}\n\n.academictable td {\n    padding: 10px !important;\n}\n\n.academic {\n    color: #121a3e;\n    font-size: 14px;\n    font-weight: normal;\n}\n\n.academic-header {\n    text-align: center;\n    font-weight: bold;\n    font-size: 16px;\n}\n\nlabel {\n    padding: 5px;\n    white-space: nowrap;\n}\n// .profile-label label{\n//     padding-right: 25px;\n// }\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    /* IE10+ CSS styles go here */\n    .team-label label {\n        padding-right: 125px; /* IE 11 and below */\n    }\n}\n\n@media only screen and (max-width: 1024px) {\n    .tab button {\n        font-size: 16px !important;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .team {\n        margin: auto;\n    }\n\n    .year {\n        margin: auto;\n    }\n\n    .filter-label {\n        margin-top: 5px !important;\n    }\n\n    .profile-info {\n        margin-left: 20px;\n    }\n\n    .loading {\n        width: 125px !important;\n        height: 125px !important;\n    }\n\n    .ejPicker {\n        padding: 0px;\n    }\n\n    .table-td {\n        font-size: 14px;\n        color: #121a3e;\n    }\n\n    .academictable td {\n        padding: 5px !important;\n    }\n\n    .profile-box {\n        margin: auto;\n    }\n\n    .profile-label label {\n        font-size: 14px !important;\n    }\n\n    .loggeduser {\n        font-size: 22px !important;\n    }\n\n    .schoolname {\n        font-size: 16px !important;\n    }\n\n    .level {\n        font-size: 13px;\n    }\n\n    .profile-athlete-info {\n        margin: auto;\n    }\n\n    .profile-bbinfo {\n        margin: auto;\n    }\n\n    .nav-text p {\n        font-size: 12px !important;\n    }\n\n    .nav-text i {\n        margin-top: 5px !important;\n    }\n\n    .table-td {\n        font-size: 13px !important;\n    }\n\n    .tab button {\n        font-size: 16px !important;\n    }\n\n    .academic-stats-module {\n        padding: 10px 0px !important;\n    }\n\n    .academic_school label {\n        color: gray;\n        font-size: 16px !important;\n    }\n\n    .academic_school p {\n        margin: 0px;\n        color: white;\n        font-size: 18px !important;\n    }\n\n    .filtertype {\n        width: 35%;\n        margin: auto;\n    }\n}\n\n@media only screen and (max-width: 425px) {\n    .tab button {\n        font-size: 14px !important;\n        // clip-path: polygon(98% 0%, 82% 0%, 100% 100%, 100% 100%, 0% 100%, 18% 0%);\n    }\n\n    .AthleteCircleClass {\n        display: inline-flex;\n    }\n\n    .AthleteAccomplishmentMobileClass {\n        display: inline-flex;\n    }\n\n    .year {\n        width: 100%;\n        padding: 0px 10px;\n    }\n}\n\n@media only screen and (min-width: 992px) {\n    .profile-box {\n        margin-left: 20px;\n        flex-wrap: nowrap;\n    }\n\n    .profile-info {\n        margin-left: 30px;\n    }\n\n    .tab-line {\n        margin-left: -50px;\n    }\n\n    .next-athlete {\n        margin-left: 100px;\n    }\n\n    .stats-calc-table {\n        width: 70%;\n        margin: auto;\n    }\n}\n\n.modal-backdrop-bg {\n    transition: opacity 300ms ease-in-out;\n    -webkit-transition: opacity 300ms ease-in-out;\n    background-color: #000;\n    opacity: 0;\n}\n\n.active .modal-backdrop-bg {\n    opacity: 0.5;\n}\n\na {\n    text-decoration: none;\n}\n\n.profilemenu {\n    float: right;\n    margin-right: 15px;\n    cursor: pointer;\n    height: 40px;\n}\n\n.loggeduser {\n    font-weight: bold;\n    font-size: 26px;\n    margin: 20px 0px 0px 0px;\n}\n\n.slider {\n    overflow-y: hidden;\n    max-height: 500px; /* approximate max height */\n    transition-property: all;\n    transition-duration: 0.5s;\n    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);\n}\n\n.nav-header {\n    height: 45px;\n    background-color: black;\n    opacity: 0.7;\n}\n\n.nav-text {\n    cursor: pointer;\n}\n\n.nav-text p {\n    padding: 0px;\n    margin: 5px 0px 0px 0px;\n    color: white !important;\n    font-size: 16px;\n}\n\n.stats-tbody td {\n    font-size: 13px;\n}\n\n.loader {\n    border: 16px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 16px solid #3498db;\n    width: 120px;\n    height: 120px;\n    -webkit-animation: spin 2s linear infinite; /* Safari */\n    animation: spin 2s linear infinite;\n    position: fixed;\n    opacity: 6;\n    margin: 100px 200px 100px 500px;\n}\n/* Safari */\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.docs {\n    flex-wrap: nowrap;\n    overflow-x: hidden;\n    width: 100%;\n}\n\n.backarrow {\n    margin-top: 65px;\n    cursor: pointer;\n    width: 35px;\n    height: 35px;\n}\n\n.updateinfo {\n    width: 100%;\n    height: 25px;\n    background-color: #be1e2d;\n    color: white;\n    font-size: 14px;\n    border-radius: 2px;\n}\n\n.updateinfo:hover {\n    opacity: 0.7 !important;\n    background-color: rgb(190, 30, 45) !important;\n}\n.content-md {\n    background-color: black !important;\n}\n\n.profile-section {\n    background: rgba(0, 0, 0, 0.47) !important;\n    margin-top: 2%;\n    padding: 5px;\n    margin-bottom: 2%;\n}\n\n.tab-section {\n    background-color: rgb(34, 36, 32);\n    border-top: 5px solid #be1e2d;\n    //border-bottom: 5px solid #BE1E2D;\n}\n\n.profile-background {\n    background-image: url(../../assets/imgs/output.jpg);\n    background-size: 100% 150%;\n}\n// .e-toolbar-item {\n//     clip-path: polygon(98% 0%, 82% 0%, 100% 100%, 100% 100%, 0% 100%, 18% 0%);\n// }\n// .e-tab-wrap {\n//     background: #7596a5;\n// }\n// .e-active.e-toolbar-item .e-tab-wrap,\n// .e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover {\n//     background: #b92230;\n// }\n.doc-title {\n    color: white !important;\n}\n\n.profile {\n    padding: 0px;\n}\n\n.arrow-down {\n    width: 0;\n    height: 0;\n    border-left: 30px solid transparent;\n    border-right: 30px solid transparent;\n    margin: auto;\n    border-top: 30px solid #be1e2d;\n    padding-bottom: 15px;\n}\n\n.alertMessage {\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    top: 0px;\n    background: #b2ae5e !important;\n    opacity: 0.45;\n    padding: 0px;\n}\n\np.alertText {\n    text-align: center !important;\n    font-size: 1.4rem;\n    color: black;\n    width: 98%;\n}\n\nion-icon.iconCloseAlert {\n    color: black;\n    font-size: 2rem;\n    padding-right: 10px;\n    cursor: pointer;\n    -webkit-margin-before: 0.5em;\n    -webkit-margin-after: 0em;\n}\n// .ejPicker{\n//     border-radius: 4px;\n//     padding: 5px 10px 0px 10px;\n//     margin-left: 10px;\n//     height: 36px;\n// }\n.ejPicker ej-datepicker {\n    border-bottom: none !important;\n    padding-left: 5px !important;\n}\n\n.ejPicker ej-datepicker:focus {\n    border-bottom: none !important;\n}\n\n.schoolname {\n    font-size: 20px;\n    color: white;\n    margin: 5px 0px 0px 0px;\n}\n\n.grid {\n    padding: 0px !important;\n}\n\n.level {\n    padding: 0px;\n    margin: 0px;\n    color: white;\n    font-size: 16px;\n}\n\n.e-input-group {\n    width: 100% !important;\n    border-width: 1px 1px 1px 1px !important;\n    border: 2px solid #efefef !important;\n    border-radius: 5px !important;\n    height: 40px !important;\n    background: white !important;\n    padding: 0px !important;\n}\nion-select {\n    border-width: 1px 1px 1px 1px !important;\n    border: 2px solid #efefef !important;\n    border-radius: 5px !important;\n    height: 40px !important;\n    background: white !important;\n    padding: 0px !important;\n    padding-right: 8px !important;\n}\n\n.stats-locker{\n    width: 40%;\n    margin: auto;\n    border: 2px solid #be1e2d !important;\n    background: #be1e2d !important;\n    color: white !important;\n    padding: 0px 5px !important;\n}\n\n.e-input-group input.e-input,\n.e-input-group input,\n.e-input-group.e-control-wrapper input.e-input,\n.e-input-group.e-control-wrapper input {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group input.e-input:focus,\n.e-input-group.e-control-wrapper input.e-input:focus {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group.e-control-wrapper .e-input-group-icon:last-child {\n    margin-right: 6px !important;\n    padding-top: 6px !important;\n}\n\n.athleteTeam {\n    margin: auto;\n    min-width: 50%;\n}\n\n.stats-calc-table {\n    margin: auto;\n}\n\n.table-td {\n    font-size: 15px;\n    color: #121a3e;\n}\n\n.loading {\n    float: right;\n    width: 175px;\n    border-radius: 50%;\n    height: 175px;\n}\n\nimg {\n    image-rendering: auto;\n    image-rendering: crisp-edges;\n    image-rendering: pixelated;\n}\n\n.stats-table-mob-th {\n    color: white;\n    font-size: 14px;\n    background: #be1e2d;\n    border: 1px solid;\n}\n\n.stats-table-mob-td {\n    background: black;\n    color: white;\n    font-size: 14px;\n    border: 1px solid;\n}\n\n.profile-label {\n    flex-wrap: nowrap;\n    padding: 0px;\n}\n\n.no-records {\n    color: white;\n    padding: 0;\n    margin: auto;\n    text-align: center;\n    font-size: 15px;\n}\n\n.modal-wrapper {\n    height: 540px !important;\n}\n\n.loading-mobile {\n    text-align: center;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n}\n\n.profile-mobile label {\n    padding: 5px;\n    font-size: 15px;\n}\n\n.doc-img:hover {\n    cursor: pointer;\n    border: 1px solid yellow !important;\n}\n\n.academic_school {\n    text-align: center;\n}\n\n.academic_school label {\n    color: gray;\n    font-size: 16px;\n}\n\n.academic_school p {\n    margin: 0px;\n    color: white;\n    font-size: 22px;\n}\n\n.academic_stats {\n    border: 2px solid #be1e2d;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin: auto;\n    padding: 15px 10px 10px 10px;\n}\n\n.academic_stats label {\n    white-space: pre-line;\n    padding: 0px;\n}\n\n.awards-header {\n    text-align: center;\n    color: white;\n    font-size: 22px;\n    margin-top: 40px;\n}\n\n.awards-stats {\n    min-height: 200px;\n    background: #353535;\n    padding: 10px;\n    color: white;\n    font-size: 16px;\n}\n\n.academic-stats-module {\n    padding: 20px;\n    margin: auto;\n}\n\n.athletic-stats label {\n    color: white;\n    font-size: 18px;\n}\n\n.athletic_games {\n    font-size: 16px;\n    border: 2px solid #be1e2d;\n    width: 100px;\n    height: 80px;\n    margin: 15px auto;\n    text-align: center;\n}\n\n.athletic_games label {\n    color: gray;\n    white-space: pre-line;\n    padding: 0px;\n    font-size: 16px;\n}\n\n.athletic_games p {\n    color: white;\n    text-align: center;\n    margin: 10px 0px 0px 0px;\n    font-size: 16px;\n    display: inline-flex;\n}\n\n.offensive-stats {\n    flex-wrap: nowrap;\n    text-align: center;\n}\n\n.offensive-head {\n    color: white;\n    margin: auto;\n    font-size: 16px;\n}\n\n.defensive-head {\n    color: white;\n    margin: auto;\n    font-size: 16px;\n}\n\n.defensive-head table tbody {\n    background-color: transparent;\n}\n\n.offensive-stats table tbody {\n    background-color: transparent !important;\n    font-size: 16px;\n}\n\n.offensive-stats table {\n    height: 360px;\n}\n\n.athlete_stats_part {\n    text-align: center;\n}\n\n.athlete_stats_part label {\n    color: gray;\n    font-size: 16px;\n}\n\n.athlete_stats_part p {\n    color: white;\n    font-size: 18px;\n    margin-top: 2%;\n}\n\n.hide {\n    display: block !important;\n}\n\n.swiper-pagination-bullet-active {\n    background: #be1e2d !important;\n    opacity: 1;\n}\n\n.swiper-pagination-bullet {\n    opacity: 1;\n}\n\n.swiper-wrapper ion-slide {\n    padding: 10px;\n}\n\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n    bottom: 0px !important;\n}\n\ni {\n    border: 1px solid white;\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    width: 15px;\n    height: 15px;\n}\n\n.right {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n}\n\n.left {\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n}\n\n.athlete_statsPitcherMobile {\n    border: 2px solid #be1e2d;\n    border-radius: 50%;\n    width: 90px;\n    height: 90px;\n    margin: auto;\n    padding: 20px 10px 15px 10px;\n}\n\n.athlete_statsPitcherMobile label {\n    white-space: pre-line;\n    padding: 0px;\n}\n\n.video-button {\n    height: 30px;\n    padding: 0px 91px;\n    border-radius: 6px;\n    margin: 0 15px;\n    font-size: 15px;\n    background-color: white;\n}\n\n.docs-new {\n    border: 1px solid white;\n    padding: 20px;\n    border-radius: 50%;\n    width: 125px;\n    height: 125px;\n    margin: auto;\n    background-color: #be1e2d;\n}\n\n.nav-text i {\n    margin-top: 8px;\n}\n\n.tooltiptext {\n    visibility: hidden;\n    background-color: #be1e2d;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    margin-top: 10px;\n    margin-left: 10px;\n    padding: 10px !important;\n    position: absolute;\n    z-index: 1;\n}\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n    .tooltiptext:before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        left: 140px;\n        bottom: 100%;\n        width: 0;\n        height: 0;\n        border: 10px solid transparent;\n        border-bottom-color: #be1e2d;\n    }\n\n    .tooltiptext:after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        left: 141px;\n        bottom: 100%;\n        width: 0;\n        height: 0;\n        border: 9px solid transparent;\n        border-bottom-color: #be1e2d;\n    }\n}\n\n.doc-img:hover .tooltiptext {\n    visibility: visible;\n}\n\n.filtertype.e-control.e-dropdownlist span.e-input-group.e-control-wrapper.e-ddl {\n    background: #be1e2d !important;\n    border-color: transparent !important;\n    border-radius: 2px;\n    padding: 5px 5px 0px 5px;\n}\n\n.filtertype.e-control.e-dropdownlist span.e-input-group.e-control-wrapper.e-ddl input.e-input {\n    color: #fff !important;\n}\n\n.filtertype.e-control.e-dropdownlist span.e-input-group-icon.e-ddl-icon.e-search-icon {\n    color: #fff !important;\n}\n\n.filterRow {\n    display: inline-flex;\n    width: 100%;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.filter-picker,\n.filter-dropdown {\n    margin: 2px;\n    width: 33%;\n}\n\n.btn-results {\n    width: 17%;\n    margin: auto;\n    height: 36px;\n    background-color: #be1e2d;\n    color: white;\n    font-size: 16px;\n    border-radius: 2px;\n}\n\n@media only screen and (max-width: 767px) {\n    .btn-results {\n        width: 35% !important;\n    }\n    .updateinfo{\n        height: 35px !important;\n    }\n}\n\n.results {\n    padding: 10px 0px;\n}\n\n.row.athletic-stats {\n    padding: 0% 5%;\n}\n\n.stats-spray {\n    background: #000;\n}\n\n.filterRow label {\n    color: #fff;\n    font-size: 16px;\n    margin: auto;\n    width: 110px;\n    text-align: right;\n    padding: 0px 10px;\n}\n\n.filter-mob-lab {\n    display: inline-flex;\n    width: 100%;\n}\n\n.filter-mob-lab .filter-label {\n    width: 33%;\n    margin: auto 5px;\n    color: #fff;\n}\n\n.filter-mob-lab .filter-label p {\n    margin: 0px 5px;\n    padding: 0px;\n    text-align: left;\n}\n\n.p_label {\n    // background: #353535;\n    color: gray;\n    white-space: pre-line;\n    padding: 5px 0px;\n    font-size: 16px !important;\n    margin: 0px !important;\n}\n\n.mob-spratyStats {\n    width: 100%;\n    padding: 0px;\n}\n\n.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap .e-tab-text,\n.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text {\n    color: #fff;\n}\n\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap .e-tab-text {\n    color: #fff;\n}\n\n.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_0.e-toolbar-item.e-template.e-active {\n    background: #be1e2d;\n    border: 0px;\n    border-bottom: 5px solid #be1e2d;\n}\n\n.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_0.e-toolbar-item.e-template {\n    background: #a7a9ac;\n    border: 0px;\n    border-bottom: 5px solid #a7a9ac;\n}\n\n.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_1.e-toolbar-item.e-template.e-active {\n    background: #be1e2d;\n    border: 0px;\n    border-bottom: 5px solid #a7a9ac;\n}\n\n.e-tab-header.e-control.e-toolbar.e-keyboard div#e-item-statisticTab_1.e-toolbar-item.e-template {\n    background: #a7a9ac;\n    border: 0px;\n    border-bottom: 5px solid #be1e2d;\n}\n\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover {\n    background: transparent !important;\n}\n\n.e-toolbar-items {\n    width: 100% !important;\n}\n\n.e-toolbar .e-toolbar-items .e-toolbar-item {\n    text-align: center;\n    width: 50% !important;\n}\n\n.e-tab-text {\n    text-transform: none !important;\n}\n\ndiv#e-item-statisticTab_0 {\n    background: #a7a9ac;\n    border: 1px solid white;\n}\n\ndiv#e-item-statisticTab_1 {\n    background: #a7a9ac;\n    border: 1px solid white;\n}\n\n.e-indicator.e-ignore {\n    display: none;\n}\n\n.e-tab .e-tab-header .e-indicator {\n    background: transparent !important;\n}\n\n.e-tab .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:hover .e-tab-text {\n    color: #fff !important;\n}\n\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover {\n    background: #a7a9ac;\n}\n\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-text,\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:hover .e-tab-icon {\n    color: #fff !important;\n}\n\n.e-tab-header.e-control.e-toolbar.e-keyboard {\n    width: 100% !important;\n    margin: auto;\n}\n\n.mob-range-filters p {\n    color: #fff;\n    font-size: 16px;\n    width: 50%;\n    margin: 10px auto;\n}\n\n.mob-filters {\n    display: inline-flex;\n    width: 100%;\n}\n\n.mob-filters div {\n    width: 100%;\n}\n\n.mob-filters .mob-filter-dropdown {\n    width: 80%;\n    margin: auto;\n}\n\n.e-hscroll-content {\n    display: block !important;\n}\n\n.e-toolbar-items.e-control.e-hscroll.e-touch {\n    display: inline !important;\n}\n\n.e-content.e-control.e-touch {\n    /*height: auto !important;*/\n}\n\ndiv#ej2-datetimepicker_39_popup {\n    left: 35px;\n}\n\n@media only screen and (min-device-width: 425px) and (max-device-width: 768px) {\n    .athlete_statsMobile,\n    .athletic_games {\n        width: 120px;\n    }\n}\n\n.reset {\n    cursor: pointer;\n    padding-left: 10px;\n    color: #fff;\n    text-decoration: underline;\n    font-size: 15px;\n}\n\n.reset:hover {\n    opacity: 1 !important;\n}\n\n.results div {\n    width: 100%;\n    text-align: center;\n}\n// svg#chart-container_svg {\n//   height: 250px !important;\n// }\nrect#chart-container_ChartBorder {\n    height: auto;\n}\n// .chart-area{\n//   background: #000;\n// }\n.chart-div {\n    background: #000;\n}\n\n.add-banner {\n    height: 50px;\n}\n\n.dot-1b {\n    background-color: #000;\n}\n\n.dot-2b {\n    background-color: blue;\n}\n\n.dot-3b {\n    background-color: orange;\n}\n\n.dot-hr {\n    background-color: #fff;\n}\n\n.dot-out {\n    background-color: red;\n}\n\n.legend {\n    display: inline-flex;\n}\n// .dot-1b{\n//   box-shadow: 0px 0px 0px 1px #fff;\n// }\n.legend div {\n    height: 10px;\n    width: 10px;\n    margin: auto 0px auto 12px;\n    border-radius: 50%;\n}\n\n.legend label {\n    color: #fff;\n}\n\n.EJ2-Trackball {\n    display: none;\n}\n\n.out-hbp {\n    display: inline-flex;\n    margin: auto;\n}\n\n.out-hbp .athletic_games {\n    margin: auto 15px !important;\n}\n\n.e-tab .e-tab-header .e-toolbar-item .e-tab-wrap:focus .e-tab-text {\n    color: #fff !important;\n}\n\n#academic-document {\n    border-top: 5px solid #be1e2d;\n}\n\nion-backdrop {\n    cursor: default !important;\n}\n\n.share-Icon {\n    max-width: none !important;\n    margin-left: 5px;\n    cursor: pointer;\n}\n.statsTextbox {\n    border: 1px solid #c4c4c4;\n    border-radius: 3px;\n    padding: 0px;\n    box-shadow: 0 0 3px 3px #e1e1e1;\n    margin-top: 2px;\n    min-height: 35px;\n    color: white;\n    max-height: 60px;\n    //height: 50px;\n    overflow-y: scroll;\n}\n\n.textPosition {\n    padding: 5px;\n    margin: 0px;\n}\n\nlabel {\n    color: white;\n}\n.header-filter:after,\n.header-filter:before {\n    width: 100%;\n    height: 100%;\n    display: block;\n    left: 0;\n    top: 0;\n    content: \"\";\n}\n\n.header-filter::before {\n    background: rgba(0, 0, 0, 0);\n}\n\n.main-raised {\n    margin: 0px 5px 0;\n    border-radius: 6px;\n    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12),\n        0 8px 10px -5px rgba(0, 0, 0, 0.2);\n}\n.mobProfileImage {\n    z-index: 1000000000;\n    width: 150px;\n    height: 150px;\n    margin-left: 5% !important;\n    margin-top: 20%;\n    bottom: 15px;\n    position: relative;\n    border-radius: 50%;\n    border: 2px solid white;\n}\n\n.atheleteProfileImage {\n    // z-index: 1000000000;\n    width: 150px;\n    height: 150px;\n    margin-left: 5% !important;\n    margin-top: 15%;\n    bottom: 15px;\n    position: relative;\n    border-radius: 50%;\n    border: 2px solid white;\n    object-fit: cover;\n}\n\n.profileImageGridStyle {\n    height: 150px;\n    background-image: url(../../assets/imgs/IPostSports/bg_grass.jpg);\n    background-size: 100% 100%;\n}\n\n.backgroundImage {\n    background-image: url(../../assets/imgs/IPostSports/bg_grass.jpg);\n    background-size: 100% 100%;\n    height: 150px;\n}\n.shareIcon {\n    margin-top: 40%;\n    color: white;\n    font-size: 25px;\n    cursor: pointer;\n}\n.editButton {\n    padding: 0px;\n    width: 50px;\n    position: absolute;\n    right: 15px;\n    background-color: #be1e2d;\n    color: white;\n    padding: 5px;\n}\n.editButton:hover {\n    opacity: 0.7 !important;\n    background-color: rgb(190, 30, 45) !important;\n}\n.editInfo {\n    margin-top: 65px;\n}\n.shareAtheleteName {\n    z-index: 1000000;\n    margin-left: 5%;\n    margin-top: 10%;\n    font-size: 25px;\n    height: 3em;\n    overflow: hidden;\n}\n@media only screen and (min-width: 320px) and (max-width: 765px) {\n    .profile-content-height {\n        height: auto !important;\n    }\n\n    .ageColumn {\n        margin-left: 0px;\n    }\n\n    .leagueColumn {\n        margin-left: 15px;\n    }\n\n    .main-raised {\n        padding: 0px 5px 0;\n        background-color: #4e4a4b !important;\n        margin: 0 !important;\n        border-radius: 0;\n    }\n\n    .publicShare-stats {\n        /*background:black !important;*/\n        border-right: 2px solid #161717;\n    }\n\n    .shareAtheleteName {\n        z-index: 1000000;\n        margin-left: 5%;\n        margin-top: 10%;\n        font-size: 25px;\n        height: 3em;\n        overflow: hidden;\n    }\n\n    .statsTextbox {\n        color: white !important;\n        border: 2px solid white !important;\n        border-radius: 5px !important;\n        background: black !important;\n        -webkit-box-shadow: none !important;\n        box-shadow: none !important;\n        font-size: 13px;\n        height: 40px;\n        padding: 5px;\n    }\n\n    label {\n        color: white;\n        font-size: 13px;\n    }\n\n    .deskmain-raised {\n        margin: 0px !important;\n    }\n\n    .mobProfileImage {\n        z-index: 1000000000;\n        width: 150px;\n        height: 150px;\n        margin-left: 5% !important;\n        margin-top: 20%;\n        bottom: 15px;\n        position: relative;\n        border-radius: 50%;\n        border: 2px solid white;\n    }\n\n    .mobAthleteName {\n        z-index: 1000000;\n        margin-left: 42%;\n        margin-top: 11%;\n        font-size: 33px;\n    }\n\n    .legend {\n        display: inline-flex;\n    }\n\n    .headerData {\n        /*background: #161717;*/\n        background: #a7a9ac;\n        padding: 5px 0;\n        border-bottom: 1px solid #161717;\n    }\n\n    .resultData {\n        padding: 5px 0;\n    }\n\n    p.p_label {\n        font-weight: bold;\n        font-size: 16px;\n        padding: 5px 0;\n        color: black;\n    }\n}\n@media (min-width: 1200px) {\n    .container {\n        max-width: 100%;\n    }\n}\n.col-6 {\n    padding-right: 5px !important;\n    padding-left: 10px !important;\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-3 {\n    padding-right: 5px !important;\n    padding-left: 10px !important;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: none !important;\n}\n.col-12{\n    padding-right: 5px !important;\n    padding-left: 10px !important;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n.headerName {\n    font-size: 18px;\n}\n.filter-label1 {\n    width: 50%;\n    margin: auto 5px;\n    color: #fff;\n}\n\n.page-headerBg {\n    background-image: url(\"../../assets/imgs/IPostSports/bg_grass.jpg\");\n    height: 20vh;\n}\n.videoBackButton {\n    color: white;\n    background: transparent;\n    transform: translate(15px, -40px) !important;\n    font-size: 16px !important;\n    z-index: 100000;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    .profile-content-height {\n        height: auto !important;\n    }\n\n    .shareIcon {\n        margin-top: 20% !important;;\n    }\n\n    .main-raised {\n        padding: 0px 5px 0;\n        background-color: #4e4a4b !important;\n        margin: 0 !important;\n        border-radius: 0;\n    }\n\n    .publicShare-stats {\n        /*background:black !important;*/\n        border-right: 2px solid #161717;\n    }\n\n    .shareAtheleteName {\n        z-index: 1000000;\n        margin-left: 20%;\n        margin-top: 15%;\n        font-size: 25px;\n        height: 3em;\n        overflow: hidden;\n    }\n\n    .statsTextbox {\n        color: white !important;\n        border: 2px solid white !important;\n        border-radius: 5px !important;\n        background: black !important;\n        -webkit-box-shadow: none !important;\n        box-shadow: none !important;\n        font-size: 13px;\n    }\n\n    label {\n        color: white;\n        font-size: 13px;\n    }\n\n    .mobProfileImage {\n        z-index: 1000000000;\n        width: 300px;\n        height: 300px;\n        margin-left: 10%;\n        margin-top: 20%;\n        bottom: 15px;\n        position: relative;\n        border-radius: 50%;\n        border: 2px solid white;\n    }\n\n    .mobAthleteName {\n        z-index: 1000000;\n        margin-left: 42%;\n        margin-top: 11%;\n        font-size: 33px;\n    }\n\n    .legend {\n        display: inline-flex;\n    }\n\n    .page-header {\n        height: 25vh;\n        background-size: cover;\n        margin: 0;\n        padding: 0;\n        border: 0;\n        display: flex;\n        align-items: center;\n    }\n\n    .headerData {\n        /*background: #161717;*/\n        background: #a7a9ac;\n        padding: 5px 0;\n        border-bottom: 1px solid #161717;\n    }\n\n    .resultData {\n        padding: 5px 0;\n    }\n\n    p.p_label {\n        font-weight: bold;\n        font-size: 16px;\n        padding: 5px 0;\n        color: black;\n    }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n    .profile-content-height {\n        padding-top: 80px !important;\n    }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {\n    .profile-content-height {\n        padding-top: 125px !important;\n    }\n}\n\n@media only screen and (min-device-width: 320px) and (max-device-width: 765px) and (orientation: portrait) {\n    .profile-content-height {\n        padding-top: 50px !important;\n    }\n}\n\n@media only screen and (min-device-width: 320px) and (max-device-width: 765px) and (orientation: landscape) {\n    .profile-content-height {\n        padding-top: 80px !important;\n    }\n}\n\n.athletetabs-section {\n    padding-bottom: 10px;\n    width : 100%;\n}\n\n.header-style {\n    background-color: #c01e2d;\n    top: -100px;\n    width: 100%;\n    display: block;\n    transition: top 0.3s;\n    position: fixed;\n    overflow: hidden;\n    z-index: 10001;\n    padding: 5px;\n    opacity: 0.9;\n}\n\n.header,\nspan.label-name {\n    font-size: 20px;\n    color: floralwhite;\n}\n\n.athleteNameStyles {\n    color: #fff;\n    overflow: hidden;\n    white-space: nowrap;\n    font-weight: 500;\n    margin: 0px;\n    margin-bottom: 15px;\n}\n\n.ageBox {\n    flex: unset !important;\n    padding: 0px;\n}\n\n@media only screen and (min-device-width: 220px) and (max-device-width: 425px) {\n    .statsTextbox,\n    label {\n        font-size: 13px;\n    }\n}\n\n.gradeBox {\n    width: 70% !important;\n    max-width: 70% !important;\n    padding-left: 0px !important;\n}\n\n.ageBoxPosition {\n    width: 30% !important;\n    max-width: 30% !important;\n    padding-right: 0px !important;\n}\n\n//Chart tab section\n.spray-tab-header-section {\n    width: 100%;\n    text-align: center;\n    padding: 0px 0px 0px 0px !important;\n    display: flex;\n    color: #fff;\n    font-size: 16px;\n\n    .spray-tab {\n        border: 1px solid white;\n        height: 60px;\n        width: 50%;\n        background-color: transparent;\n        line-height: 60px;\n    }\n\n    .spray-active {\n        background-color: rgb(167, 169, 172);\n    }\n}\n\n.spray-hide {\n    display: none;\n}\n\n// .video-js .vjs-control .vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal {\n//     display: flex;\n//     width: 65px;\n\n//     .vjs-mute-control {\n//         width: 2em;\n//     }\n\n//     .vjs-volume-control {\n//         width: 4em;\n//     }\n// }\n\n@media only screen and (min-device-width: 515px) and (max-device-width: 1024px) {\n    p.fileName {\n        position: relative;\n        font-size: 10px;\n    }\n\n    #uploadedVideoFiles p {\n        width: 50%;\n        text-align: right;\n        float: left;\n        padding: 46px 1em;\n        top: 0;\n        margin: 0;\n    }\n\n    .videoPlacementContainer {\n        padding: 10px;\n        width: 250px;\n        float: left;\n        margin: auto;\n    }\n\n    .videoPlaceContainer {\n        width: 75%;\n        margin: 0 auto;\n        padding: 10px !important;\n      }\n}\n\n@media only screen and (max-width: 515px) {\n    p.fileName {\n        position: relative;\n        font-size: 10px;\n    }\n\n    #uploadedVideoFiles p {\n        width: calc(100% - 250px);\n        text-align: right;\n        float: left;\n        padding: 46px 1em;\n        top: 0;\n        margin: 0;\n    }\n\n    \n\n    .videoPlacementContainer {\n        padding: 10px;\n        width: 60%;\n        float: left;\n      }\n  \n      .videoPlaceContainer {\n        width: 75%;\n        margin: 0 auto;\n        padding: 10px !important;\n      }\n}\n\n::ng-deep .viewprofile-popover{\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0;\n        ion-label{\n            color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    }\n}\n\n.e-item .e-active{\n    padding: 30px 10px;\n}\n\n.share-model .modal-wrapper {\n    height: 290px !important;\n}\n.profile-10 .profile-bbinfo {\n    margin: 0px 50px;\n}\n\n.profile_label_10 {\n    width: 120px;\n    text-align: right;\n}\n\n.textContentsWidth {\n    padding: 15px;\n    padding-left: 0px;\n    width: 80%;\n    padding-bottom: 0px;\n  }\n\n.textContents {\n    width: 100%;\n    display: inline-flex;\n  }\n\n  span.fileContentsName {\n    color: white;\n  }\n\n  .menuContents {\n    width: 20%;\n  }\n\n  p.contextMenuDesign {\n    color: white;\n    font-size: 18px;\n    text-align: right;\n    padding-right: 20px;\n    margin-bottom: 0px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
